import { markDeliveryNonRetrievedInMock } from './deliveryDetail';

// Mock of the non-retrieve WRITE: simulate latency, then flip the delivery to non_retrieved in the
// shared detail mock, so a follow-up fetchDeliveryDetailMock returns the new state. Idempotent. No
// error-injection hook, like its retrieve sibling: error-path component tests inject a failing fn
// directly via DI; add one only when a dev flow needs it.
export async function nonRetrieveDeliveryMock(id: string): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, 100));
  markDeliveryNonRetrievedInMock(id);
}
